import { render, staticRenderFns } from "./Sheer.vue?vue&type=template&id=b10db1ec&"
import script from "./Sheer.vue?vue&type=script&lang=js&"
export * from "./Sheer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports